import { useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";
import MatoCityGov from "@/pages/MatoCityGov";
import SecretDoor from "@/pages/SecretDoor";
import MatoBBS from "@/pages/MatoBBS";
import AdminPanel from "@/pages/AdminPanel";
import KuzunekoRoom from "@/pages/KuzunekoRoom";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    // Force dark mode
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <MotionConfig reducedMotion="user">
          <HashRouter>
            <Routes>
              <Route path={ROUTE_PATHS.HOME} element={<Home />} />
              <Route path={ROUTE_PATHS.MATO} element={<MatoCityGov />} />
              <Route path={ROUTE_PATHS.SECRET} element={<SecretDoor />} />
              <Route path={ROUTE_PATHS.BBS} element={<MatoBBS />} />
              <Route path={ROUTE_PATHS.ADMIN} element={<AdminPanel />} />
              <Route path={ROUTE_PATHS.KUZUNEKO_ROOM} element={<KuzunekoRoom />} />
            </Routes>
          </HashRouter>
        </MotionConfig>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;